import { create } from "zustand";

interface LoadState {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const useLoadStore = create<LoadState>((set) => ({
  loading: false,
  setLoading: (loading: boolean) => set({ loading }),
}));

export { useLoadStore };
